import axios from "axios";
import { AppConfig } from "../../AppConfig";
import { LocalStorageManager } from "../storage/LocalStorageManager";
import { BlogDetailAPI } from "../api/request/blog/details";
import { BlogsAPI } from "../api/request/blog/blogs";
import { HomepageImageAPI } from "../api/request/home/homepage-image";
import { HotPropertyAPI } from "../api/request/home/hot-property";
import { InquiryFormAPI } from "../api/request/home/inquiry-form";
import { ContactFormAPI } from "../api/request/contact";
import { PropertyDetailAPI } from "../api/request/property/details";
import { CommercialListAPI } from "../api/request/property/commercial";
import { ResidentialListAPI } from "../api/request/property/residential";
import { PropertyTypeAPI, PropertyTypesAPI } from "../api/request/search/property-type";
import { PopularPlaceAPI } from "../api/request/search/popular-place";
import { DistrictAPI } from "../api/request/search/district";
import { CommuneAPI } from "../api/request/search/commune";

const USE_MOCK_API = process.env.REACT_APP_USE_MOCK_API === "true";
const API_BASE_URL = process.env.REACT_APP_API_BASE ?? "";

export const axiosInstance = axios.create({
  baseURL: USE_MOCK_API ? "" : API_BASE_URL,
  useMockApi: USE_MOCK_API,
  displayError: true,
});

axiosInstance.interceptors.request.use((config) => {
  const accessToken = LocalStorageManager.Instance.getObject<string>(
    AppConfig.Instance.LocalStorageKey["accessToken"]
  );
  config.headers = config.headers || {};
  if (accessToken) {
    config.headers["Authorization"] = `Bearer ${accessToken}`;
  }
  return config;
});

export const domainBaseURLOption = () => {
  if (process.env.REACT_APP_USE_MOCK_API === "false") {
    return {
      ...axiosInstance.options,
      baseURL: process.env.REACT_APP_API_BASE,
    };
  }
  return { ...axiosInstance.options };
};

const homepageImageApi = new HomepageImageAPI(axiosInstance);
const hotPropertyApi = new HotPropertyAPI(axiosInstance);
const inquiryFormApi = new InquiryFormAPI(axiosInstance);
const blogsApi = new BlogsAPI(axiosInstance);
const blogDetailApi = new BlogDetailAPI(axiosInstance);
const contactFormApi = new ContactFormAPI(axiosInstance);
const propertyDetailApi = new PropertyDetailAPI(axiosInstance);
const commercialListApi = new CommercialListAPI(axiosInstance);
const residentialListApi = new ResidentialListAPI(axiosInstance);
const propertyTypeApi = new PropertyTypeAPI(axiosInstance);
const propertyTypesApi = new PropertyTypesAPI(axiosInstance);
const popularPlaceApi = new PopularPlaceAPI(axiosInstance);
const districtApi = new DistrictAPI(axiosInstance);
const communeApi = new CommuneAPI(axiosInstance);

export {
  homepageImageApi,
  hotPropertyApi,
  inquiryFormApi,
  blogsApi,
  blogDetailApi,
  contactFormApi,
  propertyDetailApi,
  commercialListApi,
  residentialListApi,
  popularPlaceApi,
  propertyTypeApi,
  propertyTypesApi,
  districtApi,
  communeApi,
};